import React from "react";

const ArbeidserfaringListItem = ({children, className}) =>
    <li className={`arbeidserfaring ${className}`}>
        {children}
    </li>
;

export default ArbeidserfaringListItem;